// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__1jE_T","spinAndScale":"spinner_spinAndScale__un8Ck"};